var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.url)?_c('a',{staticClass:"content-type-item",class:{ active: _vm.active },attrs:{"href":_vm.url},on:{"click":function($event){$event.preventDefault();return _vm.click(_vm.active)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_c('div',[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }